import { datadogRum } from '@datadog/browser-rum';

let initialized = false;

/** Reset the one-time init guard. Test-only. */
export function __resetRumForTests(): void {
  initialized = false;
}

export function initRum(): void {
  // Idempotent: safe to call from every page entry script. Datadog's SDK also
  // no-ops (with a console warning) on double-init within a single document,
  // but the early return here avoids the warning and any unnecessary work.
  if (initialized) return;
  const env = import.meta.env.PUBLIC_DD_ENV;
  const applicationId = import.meta.env.PUBLIC_DD_APPLICATION_ID;
  const clientToken = import.meta.env.PUBLIC_DD_CLIENT_TOKEN;
  if (!env || !applicationId || !clientToken) return; // no-op in dev / misconfig
  initialized = true;
  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service: 'joshforanc',
    env,
    version: import.meta.env.PUBLIC_APP_VERSION ?? '0.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    // joshforanc.com is part of the districtjosh hub family, so scope the _dd_s
    // session cookie to .districtjosh.com and a single RUM session follows the
    // user across districtjosh and its project subdomains.
    trackSessionAcrossSubdomains: true,
  });
}
